<template>
  <div>
    <table class="table table-sm table-list m-0 table-mobile measurement-tiles">
      <thead>
        <tr>
          <th></th>
          <th colspan="8">Kafelki ściany(wpisujemy szerokość)</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, i) in inputTiles" :key="i">
          <td class="measurement-tiles-name">
              <template v-if="item.isEdited === false">
            <strong>
              Kafelki
              <br />
              H={{item.h}}
            </strong>
            </template>
            <template v-else>
                 <b-input-group prepend="H =">
             <b-form-input
                v-model="item.h"
                type="text"
                :formatter="numberFormat"
                placeholder="0"
                :readonly="isBusy"
              ></b-form-input>
                </b-input-group>
            </template>
          </td>
          <td v-for="(value, j) in item.width" :key="j">
            <template v-if="item.isEdited === false">{{value}}</template>
            <template v-else>
              <b-form-input
                v-model="item.width[j]"
                type="text"
                :formatter="numberFormat"
                :state="errors[i+'_'+j]"
                @update="isValidSize(item.width[j], i+'_'+j)"
                placeholder="0.00"
                :readonly="isBusy"
              ></b-form-input>
            </template>
          </td>
          <td class="measurement-tiles-options" v-if="isNotSubcontractor">
            <button
              class="btn btn-outline-primary"
              :disabled="isBusy"
              @click="startEdit(item)"
              v-if="item.isEdited === false"
            >Edytuj</button>
            <button
              class="btn btn-outline-success btn-edit"
              :disabled="isBusy"
              @click="saveEdited"
              v-if="item.isEdited === true"
            >Zapisz</button>
            <button
              class="btn btn-outline-secondary btn-delete"
              :disabled="isBusy"
              @click="resetEdited"
              v-if="item.isEdited === true"
            >
              <i class="fas fa-times"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { numberFormat } from "@/services/helpers";

export default {
  name: "MeasurementTiles",
  props: {
    tiles: {
      type: Array
    }
  },
  data() {
    return {
      editet: false,
      selected: false,
      isBusy: false,
      errors: {},
      inputTiles: [
        {
          h: "240",
          width: [0, 0, 0, 0, 0, 0, 0, 0],
          isEdited: false
        },
        {
          h: "120",
          width: [0, 0, 0, 0, 0, 0, 0, 0],
          isEdited: false
        }
      ]
    };
  },
  computed: {
    ...mapGetters("user", ["isNotSubcontractor"])
  },
  created() {
    this.$_.each(this.tiles, (item, i) => {
      this.inputTiles[i].h = this.tiles[i].h;
      this.$_.each(item.width, (width, j) => {
        this.inputTiles[i].width[j] = parseFloat(width).toFixed(2)
        this.errors[i+'_'+j] = null;
      });
    });
  },
  methods: {
    ...mapActions("construction", ["measurementTiles"]),
    numberFormat: numberFormat,
    startEdit(item) {
      if (this.selected) {
        this.selected.isEdited = false;
      }
      item.isEdited = true;
      this.selected = item;
    },
    resetEdited() {
      let origin = this.$_.find(this.tiles, { h: this.selected.h });
      if (!origin) origin = { width: [0, 0, 0, 0, 0, 0, 0, 0] };
      this.$_.each(origin.width, (v, i) => {
        this.selected.width[i] = v;
      });
      this.selected.isEdited = false;
      this.selected = false;
    },
    saveEdited() {
      this.isBusy = true;
      this.$_.each(this.selected.width, (v, i) => {
        this.selected.width[i] = parseFloat(v).toFixed(2);
      });
      let newTiles = JSON.parse(JSON.stringify(this.inputTiles));

      delete newTiles[0].isEdited;
      delete newTiles[1].isEdited;

      this.measurementTiles(newTiles)
        .then(() => {
          this.$store.commit("construction/measurementTiles", newTiles);
          this.isBusy = false;
          this.selected.isEdited = false;
          this.selected = false;
        })
        .catch(() => {
          this.isBusy = false;
        });
    },
    isValidSize(size, errorName) {
      let number = parseFloat(size);
      this.errors[errorName] =
        parseFloat(number) >= 0 && parseFloat(number) <= 999 ? null : false;
    }
  }
};
</script>